import React from "react";

function ProductSchema ({productData})  {

  const randomNumberInRange = (min, max) => {
    //  get number between min and max
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  console.log(productData)
    const product = {
      "@context": "https://schema.org",
      "@type": "Product",
      "name": productData.product_name,
      "image": productData.product_image,
      "description": productData.product_description,
      "sku": productData.product_sku,
      "brand": {
        "@type": "Brand",
        "name": "Ashna Vaswani"
      },
      "offers": {
        "@type": "Offer",
        "url": 'https://ashnavaswani.com/product/' + productData.product_slug,
        "priceCurrency": "INR",
        "price": productData.product_selling_price,
        "itemCondition": "https://schema.org/NewCondition",
        "availability": "https://schema.org/InStock"
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.5",
        "reviewCount": randomNumberInRange(50,60)
      }
    };

    return (
      <script type="application/ld+json">
        {JSON.stringify(product)}
      </script>
    );
};

export default ProductSchema;